// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2553":"ef127d9390c8d0f4","5350":"b4b6e36555d2311b","8208":"d90a0cbf6b584d12"}[chunkId] + ".js";
};